import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Grid, Typography, InputBase, Tooltip, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ChatIcon from "@material-ui/icons/Chat";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import SendIcon from "@material-ui/icons/Send";
import Dropzone from "react-dropzone";
import CancelIcon from "@material-ui/icons/Cancel";
import moment from "moment";

import CircularProgress from "@material-ui/core/CircularProgress";
import axios from "axios";
import { appUrl } from "../../../../../../../utils/config";
import { presentFormatedData } from "../../../functionalComponents/dataFormatFunctions";

const useStyles = makeStyles((theme) => ({
  chatHeading: {
    border: "1px solid #000000de",
    padding: "10px 4px 10px 4px",
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: "white",
  },
  chatSpace: {
    flex: 1,
    border: "1px solid #000000de",
    borderTop: "0px",
    borderBottom: "0px",
    backgroundColor: "#E7ECEE",
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
    maxHeight: "500px", // Set the maximum height to 500px
  },
  chatBox: {
    border: "1px solid #000000de",
    padding: "10px 4px 10px 4px",
    display: "flex",
    alignItems: "center",
  },
  chatInput: {
    width: "300px",
    marginRight: "8px",
  },
  fileAdded: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    paddingLeft: "8px",
    paddingRight: "8px",
    backgroundColor: "#e36e39",
    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px",
    position: "sticky",
    // bottom: 180,
    zIndex: 1,
  },
  // messages: {
  //   display: "flex",
  //   flexDirection: "column",
  // },

  chatMessageContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start", // Align all messages to the left
    height: "580px",
  },

  chatMessage: {
    padding: "8px",
    width: "80%",
    borderRadius: "8px",
    marginBottom: "10px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start", // Align text and email to the left
  },

  textMessage: {
    fontSize: "0.8rem",
    marginTop: "4px",
  },

  myChat: {
    alignSelf: "flex-start", // Align your messages to the left
    backgroundColor: "#dcf8c6",
    color: "#000000de",
    textAlign: "left",
    marginRight: "8px", // Add margin to your messages on the left
  },

  contactChat: {
    alignSelf: "flex-start", // Align others' messages to the left
    backgroundColor: theme.palette.background.default,
    textAlign: "left",
    marginLeft: "8px", // Add margin to others' messages on the left
  },

  emailTextContact: {
    fontSize: "0.8rem",
    color: "#2196f3",
    textAlign: "left", // Ensure email is aligned to the left
  },

  emailTextSelf: {
    fontSize: "0.8rem",
    color: "#e36e39",
    textAlign: "left", // Ensure email is aligned to the left
  },

  timeText: {
    fontSize: "0.6rem",
    color: theme.palette.text.secondary,
    textAlign: "left",
  },
}));

const ChatIndex = (props) => {
  const {
    file,
    row,
    collabrixQCSamplingID,
    collabrixUnitOperationID,
    collabrixBatchID,
    sponsorFileDetails,
    cdmoFileDetails,
    supportingFiles,
    forecastScheduleChat,
    collabrixForecastScheduleID,
  } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const didMountRef = useRef(false);

  const [latestVersion, setLatestVersion] = useState(false);
  const [chatData, setChatData] = useState([]);

  useEffect(() => {
    let relevantFileDetails = [];

    if (sponsorFileDetails || cdmoFileDetails) {
      // Determine if the file belongs to sponsorFileDetails or cdmoFileDetails
      const isSponsorFile = sponsorFileDetails
        ? sponsorFileDetails.some(
            (sponsorFile) =>
              sponsorFile.collabrixFileID === file.collabrixFileID
          )
        : null;

      if (isSponsorFile) {
        // If it's a sponsor file, compare only with sponsorFileDetails
        relevantFileDetails = sponsorFileDetails;
      } else {
        // If it's not a sponsor file, compare with cdmoFileDetails
        relevantFileDetails = cdmoFileDetails;
      }

      // Find the max version number from the relevant file details
      const maxVersion = relevantFileDetails.reduce((max, fileDetail) => {
        return Math.max(max, fileDetail.versionNumber);
      }, 0);

      // Check if the file has the latest version
      const matchingFile = relevantFileDetails.find(
        (detail) => detail.collabrixFileID === file.collabrixFileID
      );

      if (matchingFile && matchingFile.versionNumber === maxVersion) {
        setLatestVersion(true);
      } else {
        setLatestVersion(false);
      }
    }
  }, [file, cdmoFileDetails, sponsorFileDetails]);

  // const chatData = useSelector((state) => {
  //   return state.pcmp.common.Projects.reviewComments?.data
  //     ? state.pcmp.common.Projects.reviewComments?.data.reviewComments
  //     : [];
  // });
  const chatContainerRef = useRef(null);

  const [state, setState] = useState({
    customFileDetails: [],
    loading: true,
  });

  const [userMessage, setUserMessage] = useState("");

  const [error, setError] = useState("");

  const handleUserMessageChange = (event) => {
    setError("");
    setUserMessage(event.target.value);
  };

  const handleSendMessage = () => {
    if (userMessage.trim() === "" && state.customFileDetails.length === 0) {
      setError("Please add a message");
      return;
    }

    const data = {
      collabrixFileID: file?.collabrixFileID ? file?.collabrixFileID : null,
      collabrixWorkItemID: 0,
      collabrixUnitOperationID: collabrixUnitOperationID
        ? collabrixUnitOperationID
        : null,
      collabrixBatchID: collabrixBatchID ? collabrixBatchID : null,
      collabrixQCSamplingID: collabrixQCSamplingID
        ? collabrixQCSamplingID
        : null,
      reviewComments: userMessage,
      addedDate: moment().format("YYYY-MM-DDTHH:mm:ss"),
      orgID:
        localStorage.collabType !== "CMO"
          ? row?.cdmoOrgID
            ? row?.cdmoOrgID
            : null
          : row?.sponsorOrgID
          ? row?.sponsorOrgID
          : null,
      collabrixForecastScheduleID: collabrixForecastScheduleID
        ? collabrixForecastScheduleID
        : null,

      // schrockenFileID: '',
      // orgName: '',
      // chatData: {
      //   chatDetails: {
      //     schrockenChatID: '',
      //     schrockenCellCollectionID: schrockenCellCollectionID,
      //     chatSentBy: '',
      //     chatSentByOrgName: '',
      //     chatSentByRoleName: '',
      //     addedBy: '',
      //     chatTimestamp: '',
      //     chatData: userMessage,
      //     senderAccountName: '',
      //     receiverOrgID:
      //       localStorage.collabType === 'Treating Hospital'
      //         ? sponsorOrgID
      //         : treatingHospitalID,
      //     treatingHospitalID: '',
      //   },
      // },
    };

    // console.log(data)
    // dispatch(addReviewComments(data));
    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/addReviewComments`,
        data
      )
      .then((res) => {
        setState((prevState) => ({
          ...prevState,
          loading: false,
        }));
        setTimeout(() => {
          scrollChatToBottom();
        }, 100);
        if (res.status) {
          handleCallFetchReviewComments();
        } else {
          setError("Something went wrong. Please try again.");
        }
      })
      .catch((err) => {
        console.log(err);
        setError("Something went wrong. Please try again.");
      });

    setUserMessage("");
    setError("");
    setState((prevState) => ({
      ...prevState,
      customFileDetails: [],
    }));
  };

  const userMailID = useSelector((state) => {
    return state.user.userDetails.full_name;
  });

  //   const handleChangeData = (name, value) => {
  //     setError('');
  //     setState((prevState) => ({
  //       ...prevState,
  //       [name]: value,
  //     }));
  //   };

  //   const handleCustomFileUpload = (files) => {
  //     files.forEach((file) => {
  //       const reader = new FileReader();
  //       reader.readAsDataURL(file);
  //       reader.onabort = () => console.log('file reading was aborted');
  //       reader.onerror = () => console.log('file reading has failed');
  //       reader.onload = () => {
  //         let fileObject = {
  //           name: file.name,
  //           data: reader.result,
  //           customFileType: 'buffer',
  //         };
  //         handleChangeData('customFileDetails', [
  //           ...state.customFileDetails,
  //           fileObject,
  //         ]);
  //       };
  //     });
  //   };

  //   const handleCustomFileDelete = (index) => {
  //     const edit_newFiles = state.customFileDetails.filter(
  //       (file, i) => i !== index
  //     );
  //     handleChangeData('customFileDetails', edit_newFiles);
  //   };

  const handleCallFetchReviewComments = () => {
    let data = {
      collabrixFileID: file?.collabrixFileID ? file?.collabrixFileID : null,
      collabrixWorkItemID: 0,
      collabrixUnitOperationID: collabrixUnitOperationID
        ? collabrixUnitOperationID
        : null,
      collabrixBatchID: collabrixBatchID ? collabrixBatchID : null,
      collabrixQCSamplingID: collabrixQCSamplingID
        ? collabrixQCSamplingID
        : null,
      collabrixForecastScheduleID: collabrixForecastScheduleID
        ? collabrixForecastScheduleID
        : null,
    };
    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchReviewComments`,
        data
      )
      .then((res) => {
        if (res.data.status) {
          setChatData(res.data.data.reviewComments);
          // setError("Something went wrong. Please try again.");
        } else {
          setError("Something went wrong. Please try again.");
        }
      })
      .catch((err) => {
        console.log(err);
        setError("Something went wrong. Please try again.");
      });
  };

  const scrollChatToBottom = () => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  };

  // Initial mount useEffect
  useEffect(() => {
    if (didMountRef.current) {
      setState((prevState) => ({
        ...prevState,
        loading: false,
      }));
      setTimeout(() => {
        scrollChatToBottom();
      }, 100);
    } else {
      // handleCallFetchReviewComments();
      didMountRef.current = true;
    }
  }, [
    dispatch,
    chatData,
    file,
    collabrixBatchID,
    collabrixQCSamplingID,
    collabrixForecastScheduleID,
  ]);

  // Separate useEffect for collabrixUnitOperationID change
  useEffect(() => {
    if (didMountRef.current) {
      setState((prevState) => ({
        ...prevState,
        loading: true,
      }));
      handleCallFetchReviewComments();
    }
  }, [
    file,
    collabrixBatchID,
    collabrixQCSamplingID,
    collabrixForecastScheduleID,
  ]);

  // useEffect(
  //   () => {
  //     dispatch(
  //       fetchReviewComments({
  //         collabrixFileID: file?.collabrixFileID ? file?.collabrixFileID : null,
  //         collabrixWorkItemID: file?.collabrixWorkItemID
  //           ? file?.collabrixWorkItemID
  //           : null,
  //         collabrixUnitOperationID: collabrixUnitOperationID
  //           ? collabrixUnitOperationID
  //           : null,
  //         collabrixBatchID: collabrixBatchID ? collabrixBatchID : null,
  //         collabrixQCSamplingID: collabrixQCSamplingID
  //           ? collabrixQCSamplingID
  //           : null,
  //       })
  //     );
  //   },
  //   [
  //     dispatch,
  //     file,
  //     collabrixBatchID,
  //     collabrixQCSamplingID,
  //     collabrixUnitOperationID,
  //   ]
  // );

  //   function handleDownloadFile(fileID) {
  //     const data = {
  //       consentFileID: fileID,
  //     };
  //     dispatch(downloadUploadedFile(data));
  //   }

  return (
    <Grid container direction="column">
      <Grid item className={classes.chatHeading}>
        <Typography>Review Comments</Typography>
        <ChatIcon />
      </Grid>
      <Grid item className={classes.chatSpace} ref={chatContainerRef}>
        {state.loading ? (
          <div
            style={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress thickness="7" />
          </div>
        ) : (
          <div className={classes.chatMessageContainer}>
            {/* <ChatData chatData={chatData} userMailID={userMailID}  /> */}
            {chatData.map((each, index) => (
              <Paper
                key={index}
                style={{
                  alignSelf: each.addedByUserName === userMailID && "flex-end",
                }}
                className={`${classes.chatMessage} ${
                  each.addedByUserName === userMailID
                    ? classes.myChat
                    : classes.contactChat
                }`}
              >
                <Tooltip
                  title={each.addedByUserName}
                  arrow
                  placement="top-start"
                >
                  <Typography
                    className={
                      each.addedByUserName === userMailID
                        ? classes.emailTextSelf
                        : classes.emailTextContact
                    }
                  >
                    {each.addedByUserName}
                  </Typography>
                </Tooltip>

                <Typography className={classes.timeText}>
                  {moment(each.addedDate).format("MMM D, YYYY, HH:mm")}
                </Typography>
                <Typography className={classes.textMessage}>
                  {each.reviewComments}
                </Typography>
                {each.fileName && (
                  <Tooltip title="Download" arrow placement="top-start">
                    <p
                      style={{
                        color: "blue",
                        fontFamily: "Roboto",
                        cursor: "pointer",
                        marginTop: "4px",
                        fontSize: "0.8rem",
                      }}
                      //   onClick={() => handleDownloadFile(each.schrockenFileID)}
                    >
                      <u>{presentFormatedData(each.fileName, "")}</u>
                    </p>
                  </Tooltip>
                )}
              </Paper>
            ))}
          </div>
        )}
        {/* <div>
          {state.customFileDetails.map((each, i) => (
            <Grid className={classes.fileAdded} key={i}>
              <Typography>{each.name}</Typography>
              <CancelIcon
                onClick={() => handleCustomFileDelete(i)}
                style={{ cursor: 'pointer', width: '18px' }}
              />
            </Grid>
          ))}
        </div> */}
      </Grid>
      {(latestVersion ||
        collabrixQCSamplingID ||
        collabrixUnitOperationID ||
        forecastScheduleChat) && (
        <Grid item className={classes.chatBox}>
          {/* <Dropzone
             disabled={state.customFileDetails.length === 1}
             onDrop={(files) => {
               handleCustomFileUpload(files);
             }}
             accept='.csv,.xls,.xlsx,.pdf,.jpeg,.png,.jpg,.bmp,.doc,.docx,'
           >
             {({ getRootProps, getInputProps }) => (
               <div
                 {...getRootProps({
                   onDrop: (event) => event.preventDefault(),
                 })}
               >
                 <input {...getInputProps()} />
                 <AttachFileIcon
                   style={{
                     color: state.customFileDetails.length === 1 && '#888',
                     marginRight: '8px',
                     cursor:
                       state.customFileDetails.length === 0
                         ? 'pointer'
                         : 'not-allowed',
                   }}
                 />
               </div>
             )}
           </Dropzone> */}

          <InputBase
            // disabled={props.unitBatchOperations && true}
            className={classes.chatInput}
            size="small"
            name="message"
            value={userMessage}
            onChange={handleUserMessageChange}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                handleSendMessage();
              }
            }}
            placeholder="Type your message..."
          />
          <SendIcon
            onClick={handleSendMessage}
            style={{ cursor: "pointer", color: "#e36e39" }}
          />
        </Grid>
      )}

      {/* {state.customFileDetails.map((each, i) => (
        <Grid
          className={classes.fileAdded}
          style={{ justifySelf: 'flex-end' }}
          key={i}
        >
          <Typography>{each.name}</Typography>
          <CancelIcon
            onClick={() => handleCustomFileDelete(i)}
            style={{ cursor: 'pointer', width: '18px' }}
          />
        </Grid>
      ))} */}
      {error && <Typography style={{ color: "red" }}>{error}</Typography>}
    </Grid>
  );
};

export default ChatIndex;
